import { render, staticRenderFns } from "./CourseContainer.vue?vue&type=template&id=03d1ca30&scoped=true&"
import script from "./CourseContainer.vue?vue&type=script&lang=js&"
export * from "./CourseContainer.vue?vue&type=script&lang=js&"
import style0 from "./CourseContainer.vue?vue&type=style&index=0&id=03d1ca30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d1ca30",
  null
  
)

export default component.exports